import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAdminAuth } from "../../context/AdminAuthContext";
import { Loader2, Lock } from "lucide-react";
import { toast } from "sonner";

export default function AdminLogin() {
  const { login } = useAdminAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      nav("/admin");
    } catch (err) {
      toast.error(err.response?.data?.detail || "Credenciales incorrectas");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-brand-ink px-4">
      <div className="w-full max-w-sm">
        <div className="text-center mb-6">
          <div className="inline-block bg-white rounded-lg p-4">
            <img src={"/logo.svg"} alt="FABRIPAN" className="h-12 w-auto mx-auto" />
          </div>
          <p className="text-white/50 text-xs font-mono mt-3">BACKOFFICE ADMINISTRATIVO</p>
        </div>
        <form onSubmit={submit} className="bg-white rounded-sm p-6 space-y-4">
          <div className="flex items-center gap-2 font-heading font-semibold text-lg"><Lock className="h-5 w-5 text-brand" /> Acceso administrador</div>
          <input required type="email" placeholder="Email" value={email} onChange={(e) => setEmail(e.target.value)} className="w-full px-3 py-2.5 text-sm border border-border rounded-sm focus:outline-none focus:ring-1 focus:ring-primary" data-testid="admin-email" />
          <input required type="password" placeholder="Contraseña" value={password} onChange={(e) => setPassword(e.target.value)} className="w-full px-3 py-2.5 text-sm border border-border rounded-sm focus:outline-none focus:ring-1 focus:ring-primary" data-testid="admin-password" />
          <button type="submit" disabled={loading} className="w-full inline-flex items-center justify-center gap-2 bg-brand hover:bg-brand-dark disabled:opacity-60 text-white font-semibold py-3 rounded-sm transition-colors" data-testid="admin-login-submit">
            {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Entrar"}
          </button>
        </form>
      </div>
    </div>
  );
}
